import { Segment } from 'shared/models/ticket'

export const getDepartureMismatchIndexes = (
  directions: Segment[][] | undefined,
): number[] => {
  if (!directions || directions.length < 2) return []

  const indexes: number[] = []

  for (let i = 0; i < directions.length - 1; i++) {
    const prevArrivalAirport = directions[i].at(-1)?.arr?.airport?.code
    const nextDepartureAirport = directions[i + 1].at(0)?.dep?.airport?.code

    if (
      prevArrivalAirport &&
      nextDepartureAirport &&
      prevArrivalAirport !== nextDepartureAirport
    ) {
      indexes.push(i)
    }
  }

  return indexes
}
